import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import nullBind from 'utils/functions/nullBind.util';

const getIsFetching = nullBind(getAnyOrNull, 'onboarding.stylists.isFetching');
const getStylists = nullBind(getAnyOrNull, 'onboarding.stylists.stylists');

const fromArrayToPairs = (stylist) => (stylist ? [stylist.id, stylist] : null);

const selectOnboardingStylistsMap = (state) => {
  // FIXME: move this kind of logic to the reducers so this selector will be simpler

  const isFetching = getIsFetching(state);
  const stylists = getStylists(state);

  if (isFetching) return {};
  if (!stylists) return {};

  return fromEntriesToObject(stylists.map(fromArrayToPairs).filter(alwaysSame));
};

// noinspection JSUnusedGlobalSymbols
export default selectOnboardingStylistsMap;
